import { downloadCsv, get } from '@/api/base'

export const getProjectsForCompany = async companyUuid => {
  const response = await get({
    path: `admin/projects`,
    params: { company_uuid: companyUuid },
  })
  return response.success ? response.data.projects : []
}

export const getProject = async projectUuid => {
  const response = await get({
    path: `admin/projects/${projectUuid}`,
  })
  return response.success ? response.data.project : null
}

export const downloadProjectStatsCsv = async projectUuid => {
  await downloadCsv({
    path: `admin/projects/${projectUuid}/dl_stats`,
  })
}
